import { useState } from 'react';
import { Link, NavLink } from 'react-router';
import Logo from '../logo.tsx';
import { Icon } from '../ui/icon.tsx';

export default function Header({ onHomePage = false}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [effect, setEffect] = useState(false);

  function handleClick() {
    setIsMenuOpen(!isMenuOpen);
    setEffect(true);
  }

  return(
    <header id="header" className={`py-4 md:py-8 ${onHomePage ? 'absolute top-0 inset-x-0 z-10' : 'bg-black'} ${onHomePage && isMenuOpen && 'animate-fade-in-bg bg-black'}`}>
      <nav aria-label="Main navigation" className='flex flex-row justify-between items-center font-bold px-4 sm:px-8 text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl text-white'>
        <div className='flex flex-start'>
          <Link className='transition-all duration-150 ease-in-out hover:scale-105' to='/' viewTransition>
            <Logo sizes="w-[75px] h-[22px] md:w-[150px] md:h-[44px] lg:w-[187px] lg:h-[55px]"/>
          </Link>
        </div>
        <div className='flex flex-end gap-8'>
          <NavLink
            className={({ isActive, isPending }) => isActive ? "active hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : isPending ? "pending hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : "hidden lg:block transition-all duration-150 ease-in-out hover:scale-105"}
            to='/'
          >HOME</NavLink>
          <NavLink
            className={({ isActive, isPending }) => isActive ? "active hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : isPending ? "pending hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : "hidden lg:block transition-all duration-150 ease-in-out hover:scale-105"}
            to='shows'
          >SHOWS</NavLink>
          <a href="https://shop.rohnamusic.com/" target="_blank" rel="noopener noreferrer" className="hidden lg:block transition-all duration-150 ease-in-out hover:scale-105">MERCH<span className="sr-only"> (opens in new tab)</span></a>
          <NavLink
            className={({ isActive, isPending }) => isActive ? "active hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : isPending ? "pending hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : "hidden lg:block transition-all duration-150 ease-in-out hover:scale-105"}
            to='about' viewTransition
          >ABOUT</NavLink>
          <NavLink
            className={({ isActive, isPending }) => isActive ? "active hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : isPending ? "pending hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : "hidden lg:block transition-all duration-150 ease-in-out hover:scale-105"}
            to='contact' viewTransition
          >CONTACT</NavLink>
          <NavLink
            className={({ isActive, isPending }) => isActive ? "active hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : isPending ? "pending hidden lg:block transition-all duration-150 ease-in-out hover:scale-105" : "hidden lg:block transition-all duration-150 ease-in-out hover:scale-105"}
            to='epk' viewTransition
          >PRESS KIT</NavLink>
          <button
            className="flex items-center gap-2 sm:gap-3 lg:hidden cursor-pointer ease-in-out hover:scale-105"
            onClick={() => handleClick()}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? '' : 'MENU'}
            {isMenuOpen
              ? <Icon className={`${effect && 'animate-half-spin'}`} onAnimationEnd={() => setEffect(false)} name="x" size="lg" title="Close Menu"></Icon>
              : <Icon className={`${effect && 'animate-half-spin'}`} onAnimationEnd={() => setEffect(false)} name="menu" size="lg" title="Open Menu"></Icon>
            }
          </button>
        </div>

        <div id="mobile-menu" className={`text-2xl sm:text-3xl absolute w-full z-20 top-[56px] md:top-[108px] lg:hidden left-0 h-[calc(100svh-56px)] md:h-[calc(100svh-108px)] py-4 md:py-8 bg-linear-to-b from-black to-black/95 flex-col items-center gap-6 md:gap-8 ${isMenuOpen ? 'flex origin-top animate-grow' : 'hidden'}`}
        onClick={() => setIsMenuOpen(false)}>
          <NavLink
            className="lg:hidden transition-all duration-150 ease-in-out hover:scale-105"
            to='/'
            viewTransition
            onClick={() => setIsMenuOpen(false)}
          >HOME</NavLink>
          <NavLink
            className="lg:hidden transition-all duration-150 ease-in-out hover:scale-105"
            to='shows'
            viewTransition
            onClick={() => setIsMenuOpen(false)}
          >SHOWS</NavLink>
          <a
            href="https://shop.rohnamusic.com"
            target="_blank"
            rel="noopener noreferrer"
            className="lg:hidden transition-all duration-150 ease-in-out hover:scale-105"
            onClick={() => setIsMenuOpen(false)}
          >MERCH<span className="sr-only"> (opens in new tab)</span></a>
          <NavLink
            className="lg:hidden transition-all duration-150 ease-in-out hover:scale-105"
            to='about'
            viewTransition
            onClick={() => setIsMenuOpen(false)}
          >ABOUT</NavLink>
          <NavLink
            className="lg:hidden transition-all duration-150 ease-in-out hover:scale-105"
            to='contact'
            viewTransition
            onClick={() => setIsMenuOpen(false)}
          >CONTACT</NavLink>
          <NavLink
            className="lg:hidden transition-all duration-150 ease-in-out hover:scale-105"
            to='epk'
            viewTransition
            onClick={() => setIsMenuOpen(false)}
          >PRESS KIT</NavLink>
        </div>
      </nav>
    </header>
  )
};
